import styled from 'styled-components';

const DashboardContent = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
`;

export default DashboardContent;
